/**
 * helpers/logger.ts — tiny no-op-in-prod logger.
 *
 * Direct `console.log` would leak information (Bearer tokens, PII) in
 * production builds. This helper prints in dev only. Errors still go through
 * `console.error` in prod so real failures are visible in browser dev tools
 * if someone opens them, but the noisy debug logs are stripped out.
 */

const isDev = process.env.NODE_ENV !== 'production';

/* eslint-disable no-console */

export const logger = {
	debug: (...args: unknown[]): void => {
		if (isDev) console.debug(...args);
	},
	info: (...args: unknown[]): void => {
		if (isDev) console.info(...args);
	},
	warn: (...args: unknown[]): void => {
		if (isDev) console.warn(...args);
	},
	error: (...args: unknown[]): void => {
		// Always surface errors — they're rare and useful in any env.
		console.error(...args);
	},
};
